export const SUPPORT_EMAIL = 'info@ctrlchain.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const API_KEY_REQUEST_MAILTO = `${SUPPORT_MAILTO}?subject=API%20key%20request`;
